import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VisibilityService {
  private readonly document = inject(DOCUMENT);

  scrollTo(elementName: string): void {
    const firstElement: HTMLElement | null =
      this.document.querySelector(elementName);
    if (firstElement) {
      firstElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
